const useq = require('./unique-sequence');

module.exports = useq;
